import type { NavBarItem } from '@gm-commercial/navbar-model';

import GearIcon from '~/assets/icons/new/gearIcon.svg?react';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { SETTINGS_VIEW_PATH } from '~/common/models/pages/settingsPages.model';

/**
 * Builds the Settings nav item: a single entry pointing at the consolidated
 * `/settings` page.
 */
export const getSettingsNavBarItems = (): NavBarItem[] => [
  {
    label: translateText('account:settings'),
    testId: 'account-settings-header',
    icon: <GearIcon className="noFill" />,
    path: SETTINGS_VIEW_PATH,
  },
];
